import React from "react";
import { handleCalendlyForm } from "../../utils";

export default class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = this.state;
    const mailtoLink = `mailto:office@stonehengemasonry.pro?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nPhone: ${phone}\n\nMessage:\n${message}`
    )}`;
    window.open(mailtoLink, "_blank");
  };

  render() {
    return (
      <>
        <div className="contact-page">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-5">
                <div className="contact-page__content">
                  <div className="title">
                    <h2>Get In Touch</h2>
                  </div>

                  <div className="contact-page__content-single">
                    <div className="contact-page__content-single-inner">
                      <div className="icon-box">
                        <span className="icon-phone-call-1"></span>
                      </div>

                      <div className="content-box">
                        <h2>Phone</h2>
                        <p className="number1">
                          <a href="tel:774-285-3447">774-285-3447</a>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="contact-page__content-single">
                    <div className="contact-page__content-single-inner">
                      <div className="icon-box">
                        <span className="icon-email"></span>
                      </div>

                      <div className="content-box">
                        <h2>Email </h2>
                        <p className="email1">
                          <a href="mailto:office@stonehengemasonry.pro">office@stonehengemasonry.pro</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-8 col-lg-8 col-md-7">
                <div className="contact-page__form">
                  <form
                    onSubmit={this.handleSubmit}
                    className="comment-one__form contact-form-validated"
                    noValidate
                  >
                    <div className="row">
                      <div className="col-xl-6 col-lg-6">
                        <div className="comment-form__input-box">
                          <input
                            type="text"
                            placeholder="Full name"
                            name="name"
                            value={this.state.name}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6">
                        <div className="comment-form__input-box">
                          <input
                            type="email"
                            placeholder="Email address"
                            name="email"
                            value={this.state.email}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-6 col-lg-6">
                        <div className="comment-form__input-box">
                          <input
                            type="text"
                            placeholder="Phone"
                            name="phone"
                            value={this.state.phone}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6">
                        <div className="comment-form__input-box">
                          <input
                            type="text"
                            placeholder="Subject"
                            name="subject"
                            value={this.state.subject}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-12 col-lg-12">
                        <div className="comment-form__input-box text-message-box">
                          <textarea
                            name="message"
                            placeholder="Your Message"
                            value={this.state.message}
                            onChange={this.handleChange}
                          ></textarea>
                        </div>
                        <div className="flex justify-between">
                          <button
                            className="thm-btn comment-form__btn"
                            data-text="Send Message +"
                            type="submit"
                            data-loading-text="Please wait..."
                          >
                            Send Message +
                          </button>
                          <button
                            className="thm-btn comment-form__btn"
                            data-text="Schedule a Quote"
                            onClick={handleCalendlyForm}
                            type="button"
                          >
                            Schedule a Quote
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
